// src/api/user.js
import request from './request'


export function sendMobileCode(data) {
  return request({
    url: '/user/sendMobileCode',
    method: 'post',
    data
  })
}

export function mobileCodeLogin(data) {
  return request({
    url: '/user/mobileCodeLogin',
    method: 'post',
    data
  })
}

export function appCoverToWeb(data) {
  return request({
    url: '/user/appCoverToWeb',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/user/getUserInfo',
    method: 'post'
  })
}

/*
export function sendToApplication(data) {
  return request({
    //baseURL: "http://127.0.0.1:8080",
    url: '/user/sendToApplication',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })
}*/